export class BooleanFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "equals",
            "baseName": "equals",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BooleanFilters.attributeTypeMap;
    }
    constructor() {
    }
}
